import React from "react";
import ExpHelper from '../Helpers/ExpHelper';
 
const CheckDefecto = ({ nombre, check, activo, referencia, children, selectCheckBox, style }) => {
    const isActive = (activo == true || activo == undefined);
    const acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");
    const descripcion = (nombre ? nombre : "Aplicar Opci" + acentoLetraOminuscula + "n por Defecto en Interfaz de AdintaR");
    const classComponent = "default-checkbox" + (isActive ? "" : "-disabled");
  
    return (
        <div className="container-radio radio-margin" style={style} >
            <ul className="no-bullets no-padding no-margin" style={{ cursor: "pointer" }}>
                <li className="inlineListItem2 lg-margin" data-toggle="tooltip" data-placement="top" title={isActive ? null : "Valor no vigente actualmente - se desafectará al grabar"}>
                    <div className={classComponent}>
                        <input
                            id={referencia}
                            type="checkbox"
                            name={referencia}
                            checked={check}
                            disabled={!isActive}
                            onClick={(e) => { if (isActive) selectCheckBox(e); }}
                        /> 
                    </div>
                </li>
                <li className="inlineListItem2" style={{marginLeft:"-14px"}}>
                    <label
                        className="label-secondary"
                        htmlFor={referencia}
                        style={{ cursor: "pointer" }}>{descripcion}</label>
                </li>
            </ul>  
            {children}
        </div>
    );
}

export default CheckDefecto;